import { useCallback, useMemo } from 'react';
import { useAppDispatch, useAppSelector } from '../hooks';
import { loadCateringAccessRequest } from './cateringAccessActions';
import { FULL_CATERING_ACCESS } from '../../services/cateringAccessPermissions';

/**
 * The signed-in employee's Catering permissions. `load` reads them again (every page visit).
 * Brisque Admin always gets every flag, so pages that read a flag directly (`editBookings`, …) never restrict an admin.
 */
export function useCateringAccess() {
  const dispatch = useAppDispatch();
  const access = useAppSelector((s) => s.catering.access);
  const load = useCallback(() => dispatch(loadCateringAccessRequest()), [dispatch]);
  return useMemo(
    () => ({ ...access, ...(access.admin ? FULL_CATERING_ACCESS : {}), load }),
    [access, load],
  );
}
